    
    document.addEventListener('scroll', function () {
        // Oblicz wysokość strony i aktualną pozycję przewinięcia
        var scrollPosition = window.innerHeight + window.scrollY;
        var documentHeight = document.body.offsetHeight;

        // Sprawdź, czy przewinięto 150px od dołu strony
        if (documentHeight - scrollPosition < 150) {
            // Ukryj elementy
            document.querySelector('.pricing-container').style.display = 'none';
            document.querySelector('.phone-container').style.display = 'none';
        } else {
            // Pokazuje elementy, jeśli nie są blisko dołu
            document.querySelector('.pricing-container').style.display = 'block';
            document.querySelector('.phone-container').style.display = 'block';
        }
    });